var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locationBin",class:{'itemLoaded': _vm.nonempty },attrs:{"title":_vm.binTitle},on:{"click":_vm.showDetails}})
}
var staticRenderFns = []

export { render, staticRenderFns }